<template>
    <div class="information-shell">
        <div class="information">
            <div class="head">
                <div class="head-left">
                    <img class="img" src="@/assets/information.png" alt=""/>
                    <span class="span">行业资讯</span>
                </div>
                <div class="head-right">
                    <span class="span3 pointer" @click="$router.push('/journalism')">查看更多</span>
                    <img class="img2" src="@/assets/right.png" alt=""/>
                </div>
            </div>
            <div class="information-content">
                <div class="maxteacher pointer" @click="$router.push({path: '/detailss?article_id='+article_id})" v-if="article_detail.article_content">
                    <img class="img" :src="article_detail.article_img" alt=""/>
                    <div class="name">{{article_detail.article_title}}</div>
                    <div class="brief">
                        {{article_detail.article_content.replace(/<.*?>/g,'').substring(0,32)}}...
                    </div>
                </div>
                <div class="list" v-if="list.length>0">
                    <ul>
                        <li v-for="(item,index) in list" :key="index" @click="look_detail(item,index)" class="pointer">
                            <div class="dot"></div>
                            {{item.article_title}}...
                            <span>{{item.add_time}}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        article_id: 0,
        list: [],
        article_detail: {
          article_content: ''
        }
      }
    },
    mounted () {
      this.get_list()
    },
    methods: {
      get_list () {
        this.API.post('Home/article_out-get_article_list', {
          cate_id: 0,
          is_hot: 0, // 	热点聚焦 1
          is_suggest: 0, // 	精选推荐 1
          page_size: 7,
          page: this.page
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.list = res.data.article_list
          if(res.data.article_list.length>0){
            this.get_detail(res.data.article_list[0].article_id)
          }
        })
      },
      // 查看资讯详情
      look_detail (item, index) {
        this.$router.push({
          path: '/detailss?article_id=' + item.article_id
        })
      },
      get_detail (article_id) {
        this.article_id = article_id
        this.API.post('Home/article_out-get_article_detail', {
          article_id: article_id
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.article_detail = res.data.article_detail
        })
      },
    }
  }
</script>

<style lang="less" scoped>
    .information-shell {
        padding: 0 20px;
    }
    .information-content{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .information {
        margin-top: 10px;
        overflow: hidden;

        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 59px;
            margin-bottom: 15px;
            .head-left,.head-right{
                display: flex;
                align-items: center;
                height: 100%;
            }

            .img {
                width: 59px;
                height: 54px;
            }

            .span {
                height: 54px;
                margin-left: 26px;
                font-size: 36px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
            }

            .span2 {
                margin-left: 20px;
                width: 291px;
                height: 26px;
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .span3 {
                margin-right: 31px;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .img2 {
                width: 13px;
                height: 21px;
            }
        }

        .maxteacher {
            height: 450px;
            width: 550px;
            border-radius: 10px;

            .img {
                width: 448px;
                height: 253px;
            }

            .name {
                font-size: 30px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #000000;
                margin: 20px 0 20px 0;
            }

            .brief {
                width: 441px;
                font-size: 18px;
                font-family: Microsoft YaHei;
                max-height: 67px;
                font-weight: 400;
                color: #999999;
                line-height: 36px;
                margin-top: 23px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }

        .list {
            height: 450px;
            width: 60%;

            ul li {
                list-style-type: unset;
                font-size: 22px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 58px;
            }

            li{
                display: flex;
                align-items: center;
                justify-content: space-between;
                position: relative;
                .dot{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -20px;
                    width: 12px;
                    height: 12px;
                    background: #999999;
                    border-radius: 50%;
                }
                span {
                  white-space: nowrap;
                  word-break: normal;
                }
            }
        }
    }
</style>
